module.exports = ".avanto-small-container {\n  max-width: 500px;\n  margin: auto; }\n\na {\n  color: #ff8a00 !important; }\n"